@switch (columnType()) {
  @case (TableColumnType.Select) {
    <app-table-header-current-page-row-selection-checkbox />
    <!--    <app-table-header-row-selection-checkbox />-->
  }

  @default {
    @if (isSortableColumn()) {
      <div class="flex items-center justify-between">
        <span>{{ columnLabel() }}</span>

        @if (sortKey(); as sortKey) {
          <p-sortIcon [field]="sortKey!" />
        }
      </div>
    } @else {
      <span>{{ columnLabel() }}</span>
    }
  }
}
